<nav>
  <div class="navbar-wrapper">
    <app-nav-logo [navCollapsed]="navCollapsed" (onNavCollapse)="navCollapse()"></app-nav-logo>
    <app-nav-content (onNavCollapsedMob)="navCollapseMob()"></app-nav-content>
  </div>
</nav>
